import cn from 'classnames'

import { HowItWorksProps } from './HowItWorks.types'

export const HowItWorks = (props: HowItWorksProps) => {
    const { className } = props

    const steps = [
        {
            title: 'Upload financial statements in PDF',
            description: 'Upload your financial statements in PDF format to our web-based tool. This step initiates the automated review process and prepares your documents for analysis.',
        },
        {
            title: 'Start review',
            description: 'Nexly automatically identifies errors and annotates them directly in the PDF. The system streamlines your review process by highlighting potential issues and inconsistencies.',
        },
        {
            title: 'Share your comments',
            description: 'Once the review is complete, an automated checklist is generated. You can easily share the annotated PDF with your client or financial statement preparer with a single click.',
        },
    ]

    return (
        <section className={cn('px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 bg-white', className)}>
            <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>
                <div>
                    <p className='inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400'>
                        How it works
                    </p>
                </div>
                <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto'>
                    Your solution for automation
                </h2>
                <p className='text-base text-gray-700 md:text-lg'>
                    Enhance compliance with financial reporting standards and applicable laws. Reduce manual review tasks up to 90% with intelligent automation.
                </p>
            </div>
            <div className='grid gap-8 row-gap-8 lg:grid-cols-3'>
                {steps.map((step, index) => (
                    <div key={index} className='sm:text-center flex flex-col h-full'>
                        <div className='flex items-center justify-center w-24 h-24 mb-4 text-5xl font-extrabold rounded-full text-deep-purple-accent-400 bg-indigo-50 mx-auto'>
                            {index + 1}
                        </div>
                        <h6 className='mb-2 font-semibold leading-5'>{step.title}</h6>
                        <p className='max-w-md mb-3 text-sm text-gray-900 sm:mx-auto flex-grow'>
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    )
}
